import React, { useContext } from "react";

import { AuthContext } from "../../context/AuthContext";
import noProfile from "../../images/pictures/no-profile.png";
import brokenImage from "../../images/pictures/broken-image.png";

function Photo() {
  const { userData } = useContext(AuthContext);
  const photoTemp = () => {
    if (userData.photo_url) {
      if (userData.photo_url !== "") {
        return userData.photo_url;
      } else {
        return noProfile;
      }
    } else {
      return noProfile;
    }
  };

  const handleError = (e) => {
    e.target.src = brokenImage;
    e.target.title = "Broken Image";
  };

  const goTo = () => {
    const url = `https://flipcard.xyz/${userData.username}`;
    window.open(url, "_blank", "noopener");
    // window.open(url, "_blank", "noopener noreferrer");
  };

  return (
    <div className="pic-thumb">
      <img
        src={photoTemp()}
        alt="Cholis"
        title="Cholis"
        onClick={() => goTo()}
        onError={handleError}
      />
    </div>
  );
}

export default Photo;
